// extracted by mini-css-extract-plugin
export var actions = "BaseModal-module--actions--FHL8H";
export var body = "BaseModal-module--body--Jkw3O";
export var modal = "BaseModal-module--modal--trsYu";
export var root = "BaseModal-module--root--u1dRR";
export var title = "BaseModal-module--title--PfkOg";